import React from 'react';
import { LeasesBasicDetails } from '../../../elements';
import AssetsNav from '../../../elements/AssetsNav';
import AssetsMenueList from "../../../elements/AssetsMenuList";
import { Grid, Paper, Button, Typography } from '@mui/material';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';


const FinancingDetails = () => {
	return (
		<>
			<LeasesBasicDetails />
			<Paper className='lease-details-section lease-nav-module-margin'>
				<AssetsNav />
				<div className='lease-details-content lease-content-overflow'>
					<Paper square className='responsive-paper'>
						<Grid container spacing={1} className='responsive-grid' alignItems='flex-end'>
							<Grid item md={4} xs={12} className='menu-container lease-list-link-mt'>
								<AssetsMenueList pageLabel={`Financing Details`} />
							</Grid>
							<Grid item md={8} xs={12}> </Grid>
						</Grid>
					</Paper>
					<div className='lease-detail-table' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', }} >
						<Typography variant='h5' textAlign='center'>
							Coming Soon...
						</Typography>
					</div>
				</div>
			</Paper>
		</>
	);
};

export default FinancingDetails;
